export enum AmsQueryReferenceType {
  ENTRY_NUMBER = 'ENTRY_NUMBER',
  IN_BOND_NUMBER = 'IN_BOND_NUMBER',
  AIRWAY_BILL_NUMBER = 'AIRWAY_BILL_NUMBER',
  HOUSE_AIRWAY_BILL_NUMBER = 'HOUSE_AIRWAY_BILL_NUMBER',
  BILL_OF_LADING_NUMBER = 'BILL_OF_LADING_NUMBER',
}
